<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_viii"></a><a id="page_ix"></a><a id="ack"></a>ACKNOWLEDGMENTS</h2>
<p class="noindent">The author thanks the archivists and librarians who made his research possible, especially Christina Moeller of the Akademie der Künste in Berlin and Dr. Deborah Rose-Lefmann of Northwestern University. Robert Sloan of the Indiana University Press has been an ideal editor, and Harriet Lightman remains the author’s indispensable collaborator.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ack.vue?1de0fa44